module.exports = __webpack_public_path__ + "img/s3Model4.525b4d38.webp";